
import { Vue, Component, Prop } from 'vue-property-decorator';
import ItemsSummaryMobile from '@/features/shipment/components/ItemsSummaryMobile.vue';
import { PackageItem } from '@/features/shipment/types';

@Component({
  components: {
    ItemsSummaryMobile,
  },
})
export default class PackageSummaryMobile extends Vue {
  @Prop({ required: true }) packages!: PackageItem[];

  private getPackageDetailsInPlainText(item: PackageItem): string {
    const { packageType } = item;
    const weight = `${item.weight} ${item.weightUnits}`;
    const dims = (item.length && item.height && item.width)
      ? `${item.length} x ${item.width} x ${item.height} ${item.dimUnits}`
      : '';
    const insurance = item.insurance
      ? `$${item.insurance} ${(this.$t('shipment.insurance') as string).toLowerCase()}`
      : '';

    const addHandling = item.isAdditionalHandling
      ? this.$t('shipment.requiresAdditionalHandling') as string
      : '';

    const description = item.description
      ? `${this.$t('tables.description')}: ${item.description}`
      : '';

    const values = [
      packageType,
      weight,
      dims,
      insurance,
    ];

    let output = values.filter(Boolean).join(', ');

    if (addHandling) {
      output += `<br />${addHandling}`;
    }

    if (description) {
      output += `<br />${description}`;
    }

    return output;
  }
}
